export const getPricePerMonth = (yearlyPrice: number) => Math.ceil((yearlyPrice * 100) / 12) / 100;
